
<!-- Llamado a la ventana emergente de mantenimiento de la plataforma VITAL -->
<app-maintenance-modal></app-maintenance-modal>

<router-outlet></router-outlet>
<wecmp-transversales-error-handling *ngIf="showError"
  [statusCode]="statusCode"
  [labelBtnConfirmar]="'Aceptar'"
  [errorMessage]="errorMessage">
</wecmp-transversales-error-handling>
